// components/Navbar.js
// Propósito: Barra superior con tabs y acciones de autenticación.

import React from 'react';
import { useAuth } from '../context/AuthContext.js';

function Navbar({ activeTab, onTabChange, onRequireAuth }) {
  const { user, logout } = useAuth();

  function handleEnumClick() {
    if (!user) {
      onRequireAuth?.();
      return;
    }
    onTabChange('enum');
  }

  function handleEmailClick() {
    if (!user) {
      onRequireAuth?.();
      return;
    }
    onTabChange('email');
  }

  function handleProfileClick() {
    if (!user) {
      onRequireAuth?.();
      return;
    }
    onTabChange('profile');
  }

  function handleLabsClick() {
    if (!user) {
      onRequireAuth?.();
      return;
    }
    onTabChange('labs');
  }

  return (
    <nav className="glass-card d-flex align-items-center justify-content-between px-3 py-2 app-navbar light">
      <div className="d-flex align-items-center gap-3">
        <span className="brand">URL Security Analyzer</span>
        <ul className="nav nav-tabs nav-tabs-glass">
          <li className="nav-item">
            <button
              className={`nav-link dark-link ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => onTabChange('home')}
            >
              Inicio
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link dark-link ${activeTab === 'basic' ? 'active' : ''}`}
              onClick={() => onTabChange('basic')}
            >
              Análisis básico
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link dark-link ${activeTab === 'enum' ? 'active' : ''}`}
              onClick={handleEnumClick}
            >
              Enumeración
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link dark-link ${activeTab === 'email' ? 'active' : ''}`}
              onClick={handleEmailClick}
            >
              Email Analyzer
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link dark-link ${activeTab === 'labs' ? 'active' : ''}`}
              onClick={handleLabsClick}
            >
              🚀 Labs
            </button>
          </li>
          {user && (
            <li className="nav-item">
              <button
                className={`nav-link dark-link ${activeTab === 'profile' ? 'active' : ''}`}
                onClick={handleProfileClick}
              >
                Perfil
              </button>
            </li>
          )}
        </ul>
      </div>
      <div className="d-flex align-items-center gap-2">
        {user ? (
          <>
            <span className="text-dark small">{user.name || user.email}</span>
            <button className="btn btn-outline-dark btn-sm" onClick={logout}>Cerrar sesión</button>
          </>
        ) : (
          <button className="btn btn-dark btn-sm" onClick={() => onRequireAuth?.()}>Ingresar</button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
